module.exports = __webpack_public_path__ + "media/src/assets/images/quote-f51d69d58a9277071e67864d859bbfe2.svg";